import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getAvailableProducts } from '../../../selectors/products.selectors';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { OrderBuilderState } from '../../../../../reducers';

@Injectable()
export class ContractProductsOptionLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of the products
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getAvailableProducts),
      filter(availableProducts => availableProducts.length > 0),
      map(availableProducts => {
        return availableProducts.map(product => {
          return {
            id: product.comm_product.comm_product.replace(/^0+/, ''),
            name: `${product.comm_product.comm_product.replace(/^0+/, '')} / ${product.comm_product.comm_long_desc}`,
          };
        });
      }),
    );
  }
}
